<!--登录页-->
<template>
    <div id="page" :style="{ backgroundImage: theme.topBarBgColor }">
        <v-container class="fill-height mt-n15" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="4" align="center" class="ml-n10">
                    <div class="atom-spinner ml-9">
                        <div class="spinner-inner">
                            <div class="spinner-line"></div>
                            <div class="spinner-line"></div>
                            <div class="spinner-line"></div>
                            <div class="spinner-circle">
                                <v-img width="4em" src="@/assets/logo.png"></v-img>
                            </div>
                        </div>
                    </div>
                    <div
                        :style="{
                            color: theme.projectNameColor,
                            fontSize: '1.5em',
                            letterSpacing: '0.3em',
                            whiteSpace: 'nowrap',
                            fontWeight: 'bolder',
                        }"
                        class="pl-13"
                    >
                        美森汽车充电管理平台
						<!-- 新建区节能减排云平台 -->
                    </div>
                </v-col>
                <v-col cols="12" md="4"></v-col>
                <!--登录表单-->
                <v-col cols="12" md="3">
                    <el-card
                        class="pt-2 pb-4"
                        shadow="always"
                        :height="height"
                        style="background:rgba(255,255,255,0.6);border:none;border-radius: 1em;"
                    >
                        <el-form
                            :model="ruleForm"
                            status-icon
                            :rules="rules"
                            ref="ruleForm"
                            class="demo-ruleForm pl-2 pr-2"
                            label-position="top"
                        >
                            <el-form-item prop="username">
                                <el-input
                                    type="text"
                                    v-model="ruleForm.username"
                                    placeholder="用户名"
                                >
                                    <i class="el-icon-user" slot="prepend"></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="password" class="mt-1">
                                <el-input
                                    type="password"
                                    v-model="ruleForm.password"
                                    placeholder="密码"
                                    show-password
                                    @keyup.enter.native="OnKeyDown"
                                >
                                    <i class="el-icon-lock" slot="prepend"></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item v-if="isReg" prop="repassword">
                                <el-input
                                    type="password"
                                    v-model="ruleForm.repassword"
                                    placeholder="再次输入密码"
                                    show-password
                                    @keyup.enter.native="OnKeyDown"
                                >
                                    <i class="el-icon-lock" slot="prepend"></i>
                                </el-input>
                            </el-form-item>
                            <el-link
                                :underline="false"
                                v-if="text === '登录'"
                                class="float-left pb-2 mt-n2"
                                :style="{ fontSize: '1em' }"
                            >
                                <el-checkbox v-model="memory">
                                    记住密码
                                </el-checkbox>
                            </el-link>
                            <el-link
                                :underline="false"
                                v-if="text === '登录'"
                                class="float-right pb-2 mt-n2"
                                @click="forgetPassword()"
                                :style="{ fontSize: '1em', color: 'red ' }"
                            >
                                忘记密码
                            </el-link>
                            <el-button
                                :style="{
                                    width: '100%',
                                    backgroundColor: bc,
                                    color: '#fff',
                                    borderRadius: '0.4em',
                                }"
                                id="login-btn"
                                class="mt-1"
                                @click="onClick('ruleForm')"
                            >
                                {{ text }}
                            </el-button>
                            <el-link
                                :underline="false"
                                class="float-right mt-2"
                                @click="reg()"
                                :style="{
                                    fontSize: '1em',
                                    color: text1 === '已有账号？登录' ? '#f76707' : 'black',
                                }"
                            >
                                {{ text1 }}
                            </el-link>
                        </el-form>
                    </el-card>
                </v-col>
            </v-row>
        </v-container>
        <!-- 登录进度遮罩层 -->
        <v-overlay :value="overlay" opacity="0.15">
            <div id="load-container">
                <div id="boxLoading"></div>
            </div>
        </v-overlay>
    </div>
</template>
<script>
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
import Public from "@/public";
export default {
    name: "Login",
    data() {
        const validateUserName = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("用户名不能为空"));
            } else {
                callback();
            }
        };
        const validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.ruleForm.repassword !== "") {
                    this.$refs.ruleForm.validateField("repassword");
                }
                callback();
            }
        };
        const validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            overlay: false,
            isregister: false,
            isReg: false,
            height: "12em",
            text: "登录",
            text1: "注册",
            ruleForm: {
                username: "",
                password: "",
                repassword: "",
            },
            rules: {
                username: [{ validator: validateUserName, trigger: "input" }],
                password: [{ validator: validatePass, trigger: "input" }],
                repassword: [{ validator: validatePass2, trigger: "input" }],
            },
            bc: "#1971c2",
            memory: false, //记住密码
        };
    },
    computed: {
        ...mapState(["user", "theme"]),
    },
    watch: {
        memory: {
            handler(val) {
                if (val === false) {
                    localStorage.removeItem("account");
                }
            },
        },
    },
    created() {
        this.$router.push({ path: "/" }).catch(err => {});
        let account = Public.decrypt(localStorage.getItem("account"));
        if (!account) {
            return;
        }
        let data = {
            username: account.user,
            password: account.password ? account.password : null,
            repassword: "",
        };
        if (data.password) {
            this.memory = true;
        }
        this.ruleForm = data;
    },
    methods: {
        onClick(ruleForm) {
            this.$refs[ruleForm].validate(valid => {
                if (valid) {
                    this.overlay = true;
                    if (this.isregister) {
                        let postData = {
                            user: this.ruleForm.username,
                            password: this.ruleForm.password,
                        };
                        this.axios
                            .post("/api/register", postData)
                            .then(response => {
                                let data = response.data;
                                if (data.result === "OK") util.ShowTip(data.data, 1);
                                else util.ShowTip(data.msg, 2);
                            })
                            .catch(() => {
                                console.log(error);
                                util.ShowTip("网络错误", 2);
                            });
                        this.overlay = false;
                    } else {
                        let postData = {
                            user: this.ruleForm.username,
                            password: this.ruleForm.password,
                        };
                        let params = {
                            postData: postData,
                            callback1: () => {
                                this.overlay = false;
                            },
                            callback2: () => {
                                if (this.memory) {
                                    let account = Public.encrypt(postData);
                                    localStorage.setItem("account", account);
                                }
                            },
                        };
                        store.dispatch("login", params);
                    }
                } else {
                    this.$message.error("请输入用户名密码");
                    return false;
                }
            });
        },
        reg() {
            if (this.text1 === "注册") {
                this.isReg = true;
                this.text = "注册";
                this.text1 = "已有账号？登录";
                this.height = "17em";
                this.isregister = true;
                this.bc = "#51cf66";
            } else if (this.text1 === "已有账号？登录") {
                Object.keys(this.ruleForm).forEach(key => {
                    this.ruleForm[key] = "";
                });
                this.isReg = false;
                this.text = "登录";
                this.text1 = "注册";
                this.height = "12em";
                this.isregister = false;
                this.bc = "#1971c2";
            }
        },
        OnKeyDown(KeyboardEvent) {
            if (KeyboardEvent.key === "Enter") {
                this.onClick("ruleForm");
            }
        },
        //忘记密码
        forgetPassword() {
            util.ShowTip("请联系超管", 0);
        },
    },
};
</script>
<style lang="scss" scoped>
#page {
    // background-image: url("../assets/bj.jpg");
    background-size: cover;
    background-color: #e9ecef;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
}
#login-btn:hover {
    background-color: #364fc7 !important;
}
#load-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 auto;
    #boxLoading {
        width: 50px;
        height: 50px;
        margin: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        &:before {
            content: "";
            width: 50px;
            height: 5px;
            background: #000;
            opacity: 0.1;
            position: absolute;
            top: 59px;
            left: 0;
            border-radius: 50%;
            animation: shadow 0.5s linear infinite;
        }
        &:after {
            content: "";
            width: 50px;
            height: 50px;
            background: #00adb5;
            animation: animate 0.5s linear infinite;
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 3px;
        }
    }
}

@keyframes animate {
    17% {
        border-bottom-right-radius: 3px;
    }
    25% {
        transform: translateY(9px) rotate(22.5deg);
    }
    50% {
        transform: translateY(18px) scale(1, 0.9) rotate(45deg);
        border-bottom-right-radius: 40px;
    }
    75% {
        transform: translateY(9px) rotate(67.5deg);
    }
    100% {
        transform: translateY(0) rotate(90deg);
    }
}

@keyframes shadow {
    0%,
    100% {
        transform: scale(1, 1);
    }
    50% {
        transform: scale(1.2, 1);
    }
}

.atom-spinner,
.atom-spinner * {
    box-sizing: border-box;
}

.atom-spinner {
    height: 60px;
    width: 60px;
    overflow: hidden;
}

.atom-spinner .spinner-inner {
    position: relative;
    display: block;
    height: 100%;
    width: 100%;
}

.atom-spinner .spinner-circle {
    display: block;
    position: absolute;
    color: #ff1d5e;
    font-size: calc(60px * 0.24);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.atom-spinner .spinner-line {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation-duration: 1s;
    border-left-width: calc(60px / 25);
    border-top-width: calc(60px / 25);
    border-left-color: #5c5edc;
    border-left-style: solid;
    border-top-style: solid;
    border-top-color: transparent;
}

.atom-spinner .spinner-line:nth-child(1) {
    animation: atom-spinner-animation-1 1s linear infinite;
    transform: rotateZ(120deg) rotateX(66deg) rotateZ(0deg);
}

.atom-spinner .spinner-line:nth-child(2) {
    animation: atom-spinner-animation-2 1s linear infinite;
    transform: rotateZ(240deg) rotateX(66deg) rotateZ(0deg);
}

.atom-spinner .spinner-line:nth-child(3) {
    animation: atom-spinner-animation-3 1s linear infinite;
    transform: rotateZ(360deg) rotateX(66deg) rotateZ(0deg);
}

@keyframes atom-spinner-animation-1 {
    100% {
        transform: rotateZ(120deg) rotateX(66deg) rotateZ(360deg);
    }
}

@keyframes atom-spinner-animation-2 {
    100% {
        transform: rotateZ(240deg) rotateX(66deg) rotateZ(360deg);
    }
}

@keyframes atom-spinner-animation-3 {
    100% {
        transform: rotateZ(360deg) rotateX(66deg) rotateZ(360deg);
    }
}
</style>
